// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-flux{position:relative}.vue-flux .flux-transition{position:absolute}.vue-flux .complements,.vue-flux>.flux-image{position:absolute;top:0;left:0}.vue-flux .complements{right:0;bottom:0;display:flex;flex-direction:column;justify-content:space-between;z-index:45}.vue-flux .complements .remainder{flex-basis:50%}", ""]);
// Exports
module.exports = exports;
